module.exports = __webpack_public_path__ + "50b4fffd4aa81b61344132904867990b.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/gewonnen_level_5_opgewekt.mp3
// module id = 98
// module chunks = 0